import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api';
import { MessageType } from '@law-connect/types';
import { actions } from '..';

const STORE = 'lawyerConnection';
const lawyerConnectionThunk = {
  fetchAll: createAsyncThunk(
    `${STORE}/fetchAll`,
    async (_, { rejectWithValue }) => {
      try {
        const response = await api.lawyerConnection.fetchAll();
        return response;
      } catch (error) {
        console.error('fetch connections', error);
        return rejectWithValue(error.message as string);
      }
    }
  ),
  fetchById: createAsyncThunk(
    `${STORE}/fetchById`,
    async (args: { id: string }, { rejectWithValue }) => {
      try {
        const { id } = args;
        const response = await api.lawyerConnection.fetchById({ id });
        return response;
      } catch (error) {
        console.error('fetch connection by id', error);
        return rejectWithValue(error.message as string);
      }
    }
  ),
  fetchMessages: createAsyncThunk(
    `${STORE}/fetchMessages`,
    async (args: { id: string }, { rejectWithValue }) => {
      try {
        const { id } = args;
        const response = await api.lawyerConnection.fetchMessages({ id });
        return response;
      } catch (error) {
        console.error('fetch message by id', error);
        return rejectWithValue(error.message as string);
      }
    }
  ),
  sendMessage: createAsyncThunk(
    `${STORE}/sendMessage`,
    async (args: { id: string; message: string }, { rejectWithValue }) => {
      try {
        const { id } = args;
        const message = await api.lawyerConnection.postMessage({
          id,
          message: args.message,
        });
        return message;
      } catch (error) {
        console.error('send message', error);
        return rejectWithValue(error.message as string);
      }
    }
  ),
  requestPermission: createAsyncThunk(
    `${STORE}/requestPermission`,
    async (args: { id: string }, { rejectWithValue }) => {
      try {
        const { id } = args;
        const message = await api.lawyerConnection.postActionMessage({
          id,
          type: MessageType.Permission,
        });
        return message;
      } catch (error) {
        console.error('send message', error);
        return rejectWithValue(error.message as string);
      }
    }
  ),
  requestClientIntake: createAsyncThunk(
    `${STORE}/requestClientIntake`,
    async (args: { id: string }, { rejectWithValue }) => {
      try {
        const { id } = args;
        const message = await api.lawyerConnection.postActionMessage({
          id,
          type: MessageType.ClientIntakeForm,
        });
        return message;
      } catch (error) {
        console.error('send message', error);
        return rejectWithValue(error.message as string);
      }
    }
  ),
  fetchUser: createAsyncThunk(
    `${STORE}/fetchUser`,
    async (args: { connectionId: string }, { rejectWithValue }) => {
      try {
        const { connectionId } = args;
        const user = await api.lawyerConnection.fetchUser({
          connectionId,
        });
        return user;
      } catch (error) {
        console.error('send message', error);
        return rejectWithValue(error.message as string);
      }
    }
  ),
  markEnded: createAsyncThunk(
    `${STORE}/markEnded`,
    async (args: { id: string }, { rejectWithValue, dispatch }) => {
      try {
        const { id } = args;
        await api.lawyerConnection.markEnded({ id });
        dispatch(actions.lawyerConnection.deleteChatMessage({ id }));
      } catch (error) {
        console.error('send message', error);
        return rejectWithValue(error.message as string);
      }
    }
  ),
  markDeleted: createAsyncThunk(
    `${STORE}/markDeleted`,
    async (args: { id: string }, { rejectWithValue, dispatch }) => {
      try {
        const { id } = args;
        await api.lawyerConnection.markDeleted({ id });
        dispatch(actions.lawyerConnection.deleteChatMessage({ id }));
      } catch (error) {
        console.error('send message', error);
        return rejectWithValue(error.message as string);
      }
    }
  ),
  deleteChatMessage: createAsyncThunk(
    `${STORE}/delete-chat-message`,
    async (args: { id: string }, { rejectWithValue }) => {
      try {
        const { id } = args;
        const message = await api.lawyerConnection.postActionMessage({
          id,
          type: MessageType.Closed,
        });
        return message;
      } catch (error) {
        console.error('delete chat message', error);
        return rejectWithValue(error.message as string);
      }
    }
  ),
  fetchLawyersByIds: createAsyncThunk(
    `${STORE}/fetchLawyersByIds`,
    async (args: { 
      connectionId: string, 
      lawyerIds: string[] 
    }, { rejectWithValue }) => {
      try {
        const { connectionId, lawyerIds } = args;
        const lawyers = await api.lawyerConnection.fetchLawyersByIds({ 
          connectionId, 
          lawyerIds 
        });
        return lawyers;
      } catch (error) {
        console.error('fetch lawyers by ids', error);
        return rejectWithValue(error.message as string);
      }
    }
  ),
  requestContactInformation: createAsyncThunk(
    `${STORE}/requestContactInformation`,
    async (args: { id: string }, { rejectWithValue }) => {
      try {
        const { id } = args;
        const message = await api.lawyerConnection.postActionMessage({
          id,
          type: MessageType.ContactInformation,
        });
        return message;
      } catch (error) {
        console.error('request contact information', error);
        return rejectWithValue(error.message as string);
      }
    }
  ),
};

export default lawyerConnectionThunk;
